// extracted by mini-css-extract-plugin
module.exports = {"container":"_1JTI7H","placeholder":"_2DJzcA","withShadow":"_2G6XVX","button":"_3jbCBM","shine-lines":"_3AdlTY"};